<template lang="pug">
    tr

        // User Full Name
        td {{ item.fullName }}

        // User Email
        td {{ item.business ? item.business.name : '' }}

        // Days meditated
        td {{ item.totalDailyViews }}

        // Completed sessions
        td {{ item.completedSessions }}

</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon
        },
        filters: {
            phoneNumber,
            formattedDate
        },
        props: {
            item: VueTypes.object.def({}),
            customFields: VueTypes.array.def([])
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin', 'showDepartment']),

            customColumn: function() {
                let itemFieldsCount = this.item.additionalInformation
                    ? this.item.additionalInformation.length
                    : null;
                let customFieldsCount = this.customFields.length;
                let column = [];

                if (customFieldsCount - itemFieldsCount >= 1) {
                    column.push({});
                }
                if (customFieldsCount - itemFieldsCount >= 2) {
                    column.push({});
                }

                return column;
            }
        },
        methods: {
            ...mapActions('users', ['deleteAccount']),
            /**
             * Edit business
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.users.edit',
                    params: { id: this.item.id }
                });
            },
            /**
             * Edit business
             */
            statisticsView() {
                this.$router.push({
                    name: 'dashboard.statistics.by.user',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete business.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount(this.item.id);

                if (resp) {
                    if (
                        this.$router.currentRoute.name ===
                        'dashboard.users.by.business'
                    ) {
                        this.$router.go(this.$router.currentRoute);
                    } else {
                        this.$emit('removed', this.item.id);
                    }
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .actions
        min-width: 115px
</style>
